/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import './css/ArticleThumbnail5.css';
import { NavLink, useHistory } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';
import { getFullDateStringFromDate, getLocalTimeFromDatabaseTime } from '../../../../catalog/DateTime';
import { context } from '../../../../globalState/GlobalState';
import Button1 from '../../buttons/Button1';
import { isValidString } from '../../../../catalog/Validity';

const ArticleThumbnail5 = (props) => {
    const history = useHistory();
    const { article } = props;
    const { globalState } = useContext(context);

    const getTitle = (title) => {
        if (title.length > 40) {
            return `${title.substr(0, 40)}...`;
        }
        return title;
    };

    const getContent = (content) => {
        if (content.length > 50) {
            return `${content.substr(0, 30)}...`;
        }
        return content;
    };

    const styles = StyleSheet.create({
        content: {
            color: globalState.websiteStyles.colors.primaryColor,
        },
    });

    return (
        <NavLink to={`/articles/${article.id}`} className="article-thumbnail5-container text-left-align full-width bg-white text-black text-no-underline">
            <div className="article-thumbnail5">
                <p className="article-thumbnail5-title alegreya-font-family font-weight-800 font-size-4xl m-t-40px m-b-0 m-l-50px m-r-30px">{getTitle(article.title)}</p>
                {/* <div className="article-thumbnail5-content alegreya-font-family font-weight-500 m-t-10px m-b-0 m-l-60px m-r-30px">
                    {parse(article.content)}
                </div> */}
                <p className={`article-thumbnail5-author font-size-s alegreya-font-family font-weight-500 m-t-10px m-b-0 m-l-50px m-r-30px ${css(styles.content)}`}>{isValidString(article.author) ? `By: ${article.author}` : `By: ${globalState.teamAlias}`}</p>
                <div className="article-thumbnail5-button m-t-30px m-l-50px m-r-20px">
                    <Button1
                        title="Read More"
                        transparent
                        backgroundColor={globalState.websiteStyles.colors.primaryColor}
                        fontColor={isValidString(globalState.websiteStyles.colors.fontColor) ? `${globalState.websiteStyles.colors.fontColor}` : 'white'}
                        borderRadius="10px"
                        fontSize="0.8rem"
                        width="140px"
                        onClick={() => { history.push('/roster'); }}
                    />
                </div>
                <img className="article-thumbnail5-logo" src={globalState.logo.logo2} alt={isValidString(globalState.teamName) ? globalState.teamName : 'Team Logo'} />
            </div>
        </NavLink>
    );
};

ArticleThumbnail5.propTypes = {
    article: PropTypes.object.isRequired,
};

export default memo(ArticleThumbnail5);
